import React, { useState } from 'reactn';
import { AppBar, Toolbar, IconButton, Typography, Box, Button, Hidden } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import CustomLink from './CustomLink';
import ButtonLink from './ButtonLink';
import ColoredButton from './ColoredButton';
import UserMenu from './UserMenu';

const links = [
	{
		name: 'Loot Simulator',
		link: '/monsters'
	},
	{
		name: 'Clue Simulator',
		link: '/clues'
	},
	{
		name: 'Raids Simulator',
		link: '/raids'
	},
	{
		name: 'Old School Bot',
		link: '/oldschoolbot'
	}
];

export interface HeaderProps {
	customToolbar?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = (props) => {
	const [menuOpen, setMenuOpen] = useState(false);
	return (
		<AppBar position="static">
			<Toolbar>
				<Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
					<CustomLink to="/">
						<Typography color="secondary" variant="h6" component="h1">
							Oldschool.gg
						</Typography>
					</CustomLink>

					<Box
						component="nav"
						display="flex"
						flexDirection="row"
						justifyContent="space-between"
						alignItems="center"
					>
						<Hidden smDown>
							<ColoredButton
								hoverBgColor="#d83c44"
								bgColor="#FF424D"
								size="small"
								component="a"
								href="https://www.patreon.com/oldschoolgg"
								color="secondary"
								target="_blank"
							>
								Patreon
							</ColoredButton>
							{links.map((link) => (
								<Button
									key={link.link}
									component={ButtonLink}
									to={link.link}
									color="secondary"
								>
									{link.name}
								</Button>
							))}
							<UserMenu />
						</Hidden>

						<Hidden mdUp>
							<IconButton
								onClick={() => setMenuOpen(!menuOpen)}
								edge="start"
								color="inherit"
								aria-label="menu"
							>
								<MenuIcon />
							</IconButton>
						</Hidden>
					</Box>
				</Box>
			</Toolbar>
			{Boolean(props.customToolbar) ? props.customToolbar : null}
		</AppBar>
	);
};

export default Header;
